import { useState, useEffect } from 'react';
import logo from '../assets/logo.png';
import s from './Nav.module.css';

const NAV_LINKS = [
  { label: 'Services', href: '#services' },
  { label: 'About',    href: '#about'    },
  { label: 'Team',     href: '#team'     },
  { label: 'Contact',  href: '#contact'  },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open,     setOpen]     = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  return (
    <>
      <nav className={`${s.nav} ${scrolled ? s.scrolled : ''}`}>
        <a href="#" className={s.logo}>
          <img src={logo} alt="Next IT Era" className={s.logoImg} />
        </a>

        <div className={s.links}>
          {NAV_LINKS.map(l => (
            <a key={l.label} href={l.href} className={s.link}>{l.label}</a>
          ))}
        </div>

        <div className={s.right}>
          <a href="#contact" className={s.cta}>Let's Talk</a>
          <button className={s.hamburger} onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {[0,1,2].map(i => (
              <span key={i} className={s.bar} style={{
                transform:
                  open && i===0 ? 'rotate(45deg) translate(5px,5px)'
                  : open && i===2 ? 'rotate(-45deg) translate(5px,-5px)'
                  : 'none',
                opacity: open && i===1 ? 0 : 1,
                background: open ? '#fff' : 'rgba(255,255,255,.45)',
              }}/>
            ))}
          </button>
        </div>
      </nav>

      <div className={s.drawer} style={{
        transform:  open ? 'translateY(0)' : 'translateY(-110%)',
        visibility: open ? 'visible' : 'hidden',
        transition: `transform .3s ease, visibility 0s ${open ? '0s' : '.3s'}`,
      }}>
        {NAV_LINKS.map(l => (
          <a key={l.label} href={l.href} className={s.drawerLink} onClick={() => setOpen(false)}>
            {l.label}
          </a>
        ))}
        <div className={s.drawerCtaWrap}>
          <a href="#contact" className={s.drawerCta} onClick={() => setOpen(false)}>Let's Talk</a>
        </div>
      </div>
    </>
  );
}
